const React = require('react');
const ReactDOM = require('react-dom/client');
require('./lib/language').installReactTranslator();
const App = require('./App');
require('./index.css');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(React.createElement(App));
